
  import {Component, Vue} from 'vue-property-decorator';
  import * as emailValidator from 'email-validator';
  import {IAuth} from '@/modules/Auth/interfaces/auth.interface';
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import PhoneInput from "@/components/PhoneInput.vue";
  import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
  import {IFormBuilder} from "@/modules/FormBuilder/interfaces/form-builder.interface";
  import {isMobile} from "mobile-device-detect";

  @Component({
    components: {
      FormBuilderField,
      PhoneInput,
    }
  })
  export default class RegistrationForm extends Vue {
    $refs: any;
    publicPath = process.env.VUE_APP_INFO;
    formRules: any = {};
    formModel: IAuth.DataRegistration = {
      surName: '',
      firstName: '',
      email: '',
      phone: '',
    };
    needAccess = true;
    displayMessage = false;
    animateMessage = false;
    formBuilderType = IFormBuilder.FieldType;

    get formFields(): IFormBuilder.IField[] {
      let fields: IFormBuilder.IField[] = [
        { prop: 'firstName', type: IFormBuilder.FieldType.Input, label: 'Имя', },
        { prop: 'surName', type: IFormBuilder.FieldType.Input, label: 'Фамилия', },
      ];
      return fields
    }

    get messages() {
      let authUrl = IApp.RoutePath[IApp.ROUTE_NAME.PAGE_AUTHORIZATION];
      return [{
        title: 'Возможно, ваш аккаунт уже создан',
        text: `&#10142; <a href="${authUrl}" class="registration-form__message-link">Перейдите в форму авторизации</a><br>
             &#10142; Введите телефон<br>
             &#10142; Запросите SMS-пароль`,
      }, {
        title: 'Если пароль не пришёл',
        text: `&#10142; Обратитесь в УК за доступом`,
      }, {
        title: 'Нужна только платная парковка?',
        text: `&#10142; Снимите галочку «Доступ к частной парковке»`,
      },];
    }

    created() {
      this.formRules = {
        phone: [{
          validator: (rule, value, callback) => (!Boolean(value) && Boolean(this.formModel.email)) || Boolean(value) ? callback() : callback(new Error(isMobile ? ' ' : 'Заполните поле')),
          required: false,
          message: isMobile ? ' ' : 'Заполните поле',
          trigger: 'change'
        }],
        email: [{
          validator: (rule, value, callback) => this.formModel.phone || emailValidator.validate(value) ? callback() : callback(new Error(isMobile ? ' ' : 'Укажите email')),
          message: isMobile ? ' ' : 'Укажите email',
          trigger: 'change'
        }],
      };
      const defaultValidator = [{required: true, message: isMobile ? ' ' : 'Заполните поле', trigger: 'change'}];
      const propsForDefaultValidator = ['firstName', 'surName',];
      propsForDefaultValidator.forEach((prop) => Vue.set(this.formRules, prop, defaultValidator));
    }

    onSubmit() {
      this.$refs.registrationForm.validate(async (valid) => {
        this.displayMessage = true;
        if (this.needAccess) this.activateMessageAnimate();

        if (valid && !this.needAccess) {
          let registrationData: IAuth.DataRegistration = {...this.formModel};
          if (this.$route.params && this.$route.params.carNumber) {
            registrationData.carNumber = this.$route.params.carNumber;
          }
          await this.$store.dispatch('dialog/openDialog', {
            blockName: 'registration',
            dialogName: 'ofertaPopup',
            payload: {
              registrationData,
            }
          });
        }
        else return false;
      });
    }

    async goToLogin() {
      const { query } = this.$route;
      this.$router.push({ name: ROUTE_NAME.PAGE_AUTHORIZATION, query });
    }

    activateMessageAnimate() {
      this.animateMessage = true;
      setTimeout(() => {
        this.animateMessage = false;
      }, 1000);
    }
  }
